/* Accessibility behavior layer — WCAG 2.1 AA remediation, Aug 2026.
   Loaded last in layout/theme.liquid. Progressive enhancement only:
   nothing here changes visuals, and removing the file reverts it all. */
(function ($) {
  'use strict';
  if (!$) return;

  // P0-3 / P0-7: elements given role="button" (former divs / void anchors)
  // must activate with Enter and Space like a real button. Native buttons
  // and inputs are excluded so nothing fires twice.
  $(document).on('keydown', '[role="button"]:not(button):not(input)', function (e) {
    if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') {
      // Enter already activates real <a href> links; let those be.
      if (e.key === 'Enter' && this.tagName === 'A' && this.getAttribute('href') &&
          this.getAttribute('href').indexOf('javascript:') !== 0 && this.getAttribute('href') !== '#') {
        return;
      }
      e.preventDefault();
      $(this).trigger('click');
    }
  });

  // P0-6: keep aria-expanded in sync on the disclosure toggles. The theme's
  // own jQuery handlers do the opening/closing; we only mirror the state.
  function wireExpanded(sel) {
    $(document).on('click keydown', sel, function (e) {
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var el = this;
      // Wait a tick so the theme's handler runs first.
      setTimeout(function () {
        var expanded = el.getAttribute('aria-expanded') === 'true';
        el.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      }, 0);
    });
  }
  wireExpanded('.menuleft');
  wireExpanded('.js-search-destop');

  // Slick marks the track role="listbox" and slides role="option", which
  // nests links inside "interactive" elements and creates unnamed ARIA
  // inputs (axe: nested-interactive, aria-input-field-name). The carousel
  // is navigation chrome, not a listbox — strip the roles.
  function fixSlickRoles() {
    $('.slick-track[role], .slick-slide[role="option"], .slick-slide[role="tabpanel"], .slick-slide[role="tab"], .slick-list[aria-live]').each(function () {
      this.removeAttribute('role');
    });
    // slick's generated aria wiring points at ids it also mangles; on a
    // non-tab carousel these are invalid (aria-prohibited-attr etc.).
    $('.slick-slide[aria-describedby]').removeAttr('aria-describedby');
    $('.slick-slide[aria-labelledby]').removeAttr('aria-labelledby');
    $('.slick-slide[aria-controls]').removeAttr('aria-controls');
    $('.slick-slide[aria-selected]').removeAttr('aria-selected');
    // the product-gallery thumbnails ARE slick slides; restore the button
    // semantics the markup gives them once slick's roles are gone.
    $('.slick-slide.engoj_img_variant[aria-label]').attr('role', 'button');
    // dots: slick marks the list role="tablist" and its <li>s as tabs with
    // aria wiring that points at mangled ids; strip it all — the buttons
    // inside keep their own text/labels and stay keyboard-operable.
    $('.slick-dots[role]').removeAttr('role');
    $('.slick-dots li').removeAttr('role aria-hidden aria-selected aria-controls aria-describedby');
    // links/buttons inside aria-hidden (cloned/offscreen) slides must not
    // be reachable by keyboard (aria-hidden-focus)
    $('.slick-slide[aria-hidden="true"]').find('a, button, [tabindex]').attr('tabindex', '-1');
    $('.slick-slide[aria-hidden="false"]').find('a, button').each(function () {
      if (this.getAttribute('tabindex') === '-1') this.removeAttribute('tabindex');
    });
  }
  $(document).on('afterChange', '.slick-slider', function () { setTimeout(fixSlickRoles, 0); });
  $(function () { setTimeout(fixSlickRoles, 800); });
  $(document).on('init reInit', '.slick-slider', function () { setTimeout(fixSlickRoles, 0); });

  // Third-party app iframes render without a title (axe: frame-title).
  // We can name the frame from outside; its internal markup is theirs.
  $(function () {
    setTimeout(function () {
      $('iframe:not([title])').each(function () {
        this.setAttribute('title', this.id || 'Embedded app content');
      });
    }, 1500);
  });

  // Screen reader announcements (WCAG 4.1.3 Status Messages). The theme's
  // ajax cart and variant pickers update the page silently; this narrates
  // those changes into the #a11y-status live region in theme.liquid.
  function announce(msg) {
    var region = document.getElementById('a11y-status');
    if (!region) return;
    // clear first so repeating the same message re-announces
    region.textContent = '';
    setTimeout(function () { region.textContent = msg; }, 80);
  }

  // Fired by ajax-cart.js after any cart mutation (add, qty change, remove).
  $(document.body).on('ajaxCart.afterCartLoad', function (evt, cart) {
    if (cart && typeof cart.item_count === 'number') {
      announce('Cart updated. ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ' in cart.');
    } else {
      announce('Cart updated.');
    }
  });

  // Variant selection: color/size swatch radios and the fallback dropdown.
  $(document).on('change', '.swatch input[type="radio"]', function () {
    if (this.value) announce('Selected ' + this.value);
  });
  $(document).on('change', '#productSelect', function () {
    var opt = this.options[this.selectedIndex];
    if (opt) announce('Selected ' + opt.text.trim());
  });

  // P2-1: drawer/popup keyboard behavior. The theme's overlays (search
  // drawer, mini cart, login popup, mobile menu) neither close on Escape
  // nor manage focus. Each entry maps an "is open" check to its opener
  // trigger, its close control, and the element to focus on open.
  var overlays = [
    { open: function(){ return document.body.classList.contains('activedestop'); },
      trigger: '.js-search-destop', close: '.close-search.js-drawer-close', focus: '#header-search' },
    { open: function(){ var el=document.querySelector('.js-minicart'); return el && el.classList.contains('active'); },
      trigger: '.js-call-minicart', close: '.close-mini-cart', focus: '.js-minicart .close-mini-cart' },
    { open: function(){ var el=document.querySelector('.js-poup-login-destop'); return el && el.classList.contains('active'); },
      trigger: '.js-call-popup-login', close: '.js-eveland-close-login', focus: '.js-poup-login-destop input[type="email"]' },
    { open: function(){ var el=document.querySelector('.box_contentmenu'); return el && (el.classList.contains('active') || el.classList.contains('open')); },
      trigger: '.menuleft', close: '.js-eveland-close', focus: '.box_contentmenu a, .box_contentmenu [role="tab"]' }
  ];
  var lastOpener = null;
  $.each(overlays, function (_, o) {
    $(document).on('click', o.trigger, function () {
      lastOpener = this;
      var target = o.focus;
      // two attempts: after the open animation, and a retry in case the
      // first fires while the drawer is still transitioning
      setTimeout(function () {
        if (o.open()) { var f = document.querySelector(target); if (f) f.focus(); }
      }, 450);
      [900, 1800].forEach(function (delay) {
        setTimeout(function () {
          if (o.open()) {
            var f = document.querySelector(target);
            if (f && document.activeElement !== f) f.focus();
          }
        }, delay);
      });
    });
  });
  $(document).on('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    for (var i = 0; i < overlays.length; i++) {
      if (overlays[i].open()) {
        var btn = document.querySelector(overlays[i].close);
        if (btn) btn.click();
        if (lastOpener) { try { lastOpener.focus(); } catch (err) {} lastOpener = null; }
        e.preventDefault();
        return;
      }
    }
  });

  // Judge.me sets the reviewer-name color inline/late; enforce the
  // AA-passing gray after their widget renders.
  $(function () {
    setTimeout(function () {
      $('.jdgm-carousel-item__reviewer-name').css('color', '#595959');
    }, 2500);
  });

  // P1-7: keep aria-selected in sync on Bootstrap tab navs.
  $(document).on('shown.bs.tab click', '[role="tab"][data-toggle="tab"]', function () {
    var $tablist = $(this).closest('[role="tablist"]');
    $tablist.find('[role="tab"]').attr('aria-selected', 'false');
    $(this).attr('aria-selected', 'true');
  });

  // P1-6 (WCAG 2.2.2): every autoplaying carousel gets a visible
  // pause/play button. Injected after slick init; skipped for sliders
  // that don't autoplay, and for single-slide sliders — 2.2.2 only
  // applies to content that actually moves, and a lone slide never
  // rotates no matter what autoplay says (the homepage hero,
  // section-slideshow-v1, is configured with one slide today).
  function slideCount($s) {
    var slick;
    try { slick = $s.slick('getSlick'); } catch (err) { slick = null; }
    if (slick && typeof slick.slideCount === 'number') return slick.slideCount;
    return $s.find('.slick-slide').not('.slick-cloned').length;
  }
  function addPauseButtons() {
    $('.slick-initialized').each(function () {
      var $s = $(this);
      if ($s.data('a11yPauseWired')) return;
      var autoplay;
      try { autoplay = $s.slick('slickGetOption', 'autoplay'); } catch (err) { return; }
      if (!autoplay) return;
      if (slideCount($s) < 2) return;
      $s.data('a11yPauseWired', true);
      var btn = $('<button type="button" class="a11y-carousel-pause" aria-pressed="false" aria-label="Pause automatic slide rotation">&#10074;&#10074;</button>');
      btn.on('click', function () {
        var paused = btn.attr('aria-pressed') === 'true';
        if (paused) {
          $s.slick('slickSetOption', 'autoplay', true, false);
          $s.slick('slickPlay');
          btn.attr({'aria-pressed': 'false', 'aria-label': 'Pause automatic slide rotation'}).html('&#10074;&#10074;');
        } else {
          $s.slick('slickSetOption', 'autoplay', false, false);
          $s.slick('slickPause');
          btn.attr({'aria-pressed': 'true', 'aria-label': 'Resume automatic slide rotation'}).html('&#9654;');
        }
      });
      $s.css('position') === 'static' && $s.css('position', 'relative');
      $s.append(btn);
    });
  }
  $(function () { setTimeout(addPauseButtons, 800); });

  // P1-6: honor prefers-reduced-motion — stop slick autoplay entirely.
  $(function () {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      $('.slick-initialized').each(function () {
        try { $(this).slick('slickPause'); } catch (err) { /* not a slick el */ }
      });
    }
    // P1-6: pause any autoplaying slick carousel on hover and on keyboard focus.
    $(document).on('mouseenter focusin', '.slick-initialized', function () {
      try { $(this).slick('slickPause'); } catch (err) {}
    });
    $(document).on('mouseleave', '.slick-initialized', function () {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      try {
        var opts = $(this).slick('slickGetOption', 'autoplay');
        if (opts) $(this).slick('slickPlay');
      } catch (err) {}
    });
  });
})(window.jQuery);
